import React from 'react';
import CompatibleBrowsers from './CompatibleBrowsers';
import WelcomeMessage from './WelcomeMessage';
import img from '../images/Download_on_the_App_Store_Badge.svg';
export default function LoginRegisterBody({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className='w-full'>
      <h1 className='text-center text-4xl'>Welcome to the Alpaca Tracker</h1>
      <div className='mb-4 flex flex-col items-center justify-center md:flex-row'>
        <div style={{ width: '200px', height: '77px' }}>
          <a href='https://play.google.com/store/apps/details?id=com.brandonlehr.alpacatracker&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
            <img
              width='200'
              alt='Get it on Google Play'
              src='https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png'
            />
          </a>
        </div>
        <div style={{ width: '50px' }} />
        <div style={{ width: '170px' }}>
          <a href='https://apps.apple.com/us/app/alpaca-tracker/id1462547727'>
            <img
              src={img}
              alt='Download on the App Store'
              style={{ width: '100%' }}
            />
          </a>
        </div>
      </div>
      <div className='flex flex-row flex-wrap justify-around justify-items-center'>
        <div className='order-0 mb-4 min-w-[320px] max-w-162.5 self-auto ps-4'>
          <WelcomeMessage />
        </div>
        {children}
      </div>
      <CompatibleBrowsers />
    </div>
  );
}
